<template>
  <div id="contact-page">
    <div id="fullpage" >
      <div class="section contact-us">
        <div class="container">
          <h3>Contact Us</h3>
          <!-- <hr> -->
          <div class="hr1"></div>
          <h4>Still have questions? We can help!</h4>
          <form v-on:submit.prevent="verifyEmail()">
            <div class="input-group">
              <input type="email" class="form-control" placeholder="you@email.com" v-model="email" required>
              <span class="input-group-btn">
                <button class="btn btn-primary" type="submit">Signup</button>
              </span>
            </div>
          </form>
          <div class="hr2"></div>
          <div class="row">
            <div class="col-md-3 col-sm-6">
              <img src="../assets/marker.png" alt="">
              <h5>Address Details</h5>
              <p>Address line 1</p>
              <p>Street Details 2</p>
              <p>More Details 3</p>
            </div>
            <div class="col-md-3 col-sm-6">
              <img src="../assets/mail.png" alt="">
              <h5>Email Address</h5>
              <p>info@website.com</p>
              <p>support@website.com</p>
              <p>admin@website.com</p>
            </div>
            <div class="col-md-3 col-sm-6">
              <img src="../assets/phone.png" alt="">
              <h5>Telephone</h5>
              <p>+ 1 (800) 000-0001</p>
              <p>+ 1 (800) 000-0002</p>
              <p>+ 1 (800) 000-0003</p>
            </div>
            <div class="col-md-3 col-sm-6">
              <img src="../assets/clock.png" alt="">
              <h5>Office Details</h5>
              <p>Mon - Fri 11 - 6 PM</p>
              <p>Saturday - CLOSED</p>
              <p>Sunday - CLOSED</p>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-12">

              <iframe
              width="100%"
              height="300"
              frameborder="0" style="border:0"
              src="https://www.google.com/maps/embed/v1/place?key=AIzaSyBbdpihLG0mhf1dlzvs_9WMG5VXKp6Uu2E&q=Space+Needle,Seattle+WA" allowfullscreen>
            </iframe>
            </div>
          </div>
        </div>
      </div>
      <div id="footer" class="section fp-auto-height">
        <app-footer />
      </div>
    </div>
  </div>
</template>

<script>
  import AppFooter from '@/components/AppFooter'

  export default {
    name: 'contact-page',
    components: {
      AppFooter,
    },
    data () {
      return {
        footerBg: '#333',
        email: ''
      }
    },
    methods: {
      verifyEmail() {
        let vm = this;
        $.ajax({
          url: 'http://webosoftware.com/static/api.php/newsletter?filter=email,eq,' + vm.email + '&transform=1',
          type: 'GET',
          success: function(res) {
            var exist = (res.newsletter.length == 0) ? false : true;
            if (!exist) {
              $.ajax({
                url: 'http://webosoftware.com/static/api.php/newsletter',
                type: 'POST',
                data: {
                  email: vm.email
                },
                success: function(res) {
                  if (res !== 0) {
                    toastr.success('You are now subscribed to our newsletter.', 'Thank you!');
                    vm.email = '';
                  }
                }
              });
            } else {
              toastr.error('You already subscribed to our newsletter.','Already Subscribed');
            }
          }
        });
      },
    },
    mounted() {
      let vm = this;

      if($('html').hasClass('fp-enabled')){
          $.fn.fullpage.destroy('all');
      }

      $('#fullpage').fullpage({
        paddingTop: '50px',
        scrollOverflow: true,
        // responsiveWidth: 768,
          afterLoad: function(anchorLink, index) {
            // vm.nav['section' + index] = true;
            // (index == 6) ? $('#sidebar-nav').fadeOut() : $('#sidebar-nav').fadeIn()
        	},
          onLeave: function(index, nextIndex, direction){
            // vm.nav['section' + index] = false;
            // vm.sections[index - 2].enter = false;
        	},
      });

    }
  }
</script>

<style scoped lang="sass">

  #footer
    // margin-top: 30px
    background: transparent
  .section
    &.contact-us
      background: radial-gradient(circle at 50% 80%, #1d6077 0,#0b1222 55%)
    color: white
    text-align: center
    .container
      // margin: 100px auto 0 auto

    h3
      font-size: 3em
      text-transform: uppercase
      font-weight: 600
      letter-spacing: 1px
      @media screen and (max-width: 767px)
        font-size: 1.2em
    .hr1
      height: 2px
      margin: 35px 0
      background: #ffab4a
      background: -moz-linear-gradient(left,  #ffab4a 0%, #ffab4a 17%, #f83a00 100%)
      background: -webkit-linear-gradient(left,  #ffab4a 0%,#ffab4a 17%,#f83a00 100%)
      background: linear-gradient(to right,  #ffab4a 0%,#ffab4a 17%,#f83a00 100%)
      filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ffab4a', endColorstr='#f83a00',GradientType=1 )
    .hr2
      height: 2px
      margin: 35px 0
      background: #f83a00
      background: -moz-linear-gradient(left,  #f83a00 0%, #ffab4a 83%, #ffab4a 100%)
      background: -webkit-linear-gradient(left,  #f83a00 0%,#ffab4a 83%,#ffab4a 100%)
      background: linear-gradient(to right,  #f83a00 0%,#ffab4a 83%,#ffab4a 100%)
      filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#f83a00', endColorstr='#ffab4a',GradientType=1 )
    .input-group
      max-width: 300px
      margin: 20px auto
      input
        background: #333
        font-size: 12px
        color: silver
        border: none
      button
        font-size: 12px
        padding: 7.5px 15px
    h4
      color: #efa248
      font-size: 2em
      letter-spacing: 2px
      font-weight: 300
      @media screen and (max-width: 767px)
        font-size: 1em
        letter-spacing: 1px
    h5
      font-size: 1.2em
      font-weight: 600
      margin-bottom: 25px
      @media screen and (max-width: 767px)
        font-size: 1em
        // letter-spacing: 1px
    p
      line-height: 1.2em
      @media screen and (max-width: 767px)
        font-size: 12px
    .row
      margin: 20px 0
      div
        // margin-bottom: 40px
        @media screen and (max-width: 992px)
          margin-bottom: 40px
</style>



// WEBPACK FOOTER //
// ContactPage.vue?5d862ce1